import NewPasswordScene from './NewPasswordScene'
export default NewPasswordScene